import { AuthProviderName, Environment, Language } from '../app/core/models/environment';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment: Environment = {
  production: false,
  defaultLanguage: Language.fr,
  logger: {
    level: NgxLoggerLevel.DEBUG,
  },
  firebase: {
    useFirebaseEmulator: false,
    appCheckEnabled: true,
    config: {
      apiKey: 'AIzaSyBG0LOiqCBbCKVoN3ILios0oPaEQ_Iany8',
      authDomain: 'accounts.app.develop.movinmotion.net',
      databaseURL: 'https://movinmotion-develop.firebaseio.com',
      projectId: 'movinmotion-develop',
      storageBucket: 'movinmotion-develop.appspot.com',
      messagingSenderId: '621428929259',
      appId: '1:621428929259:web:7cdd771406b95e3fec44ae',
      keyId: '6LdbpgssAAAAAA4YJuY5DfAwgAb9CKAzBP4pQy2n',
    },
  },
  queryParamsKeys: {
    redirectUrl: 'mmr',
    resetPassword: 'mmrp',
    changePassword: 'mmcp',
    email: 'mme',
    autoConnectUrl: 'mmac',
    language: 'mml',
    display: 'mmd',
    providerConnection: 'mmpc',
  },
  displayByAppHostEnabled: true,
  providers: {
    [AuthProviderName.myId]: {
      id: 'saml.dlp-myid',
      enabled: false,
    },
    [AuthProviderName.tohero]: {
      id: 'oidc.tohero',
      enabled: true,
    },
    [AuthProviderName.movinmotion]: {
      id: 'oidc.movinmotion',
      enabled: true,
    },
    [AuthProviderName.deezer]: {
      id: 'oidc.deezer',
      enabled: true,
    },
  },
  subscribeUrl: 'https://www.movinmotion.com/inscription/',
  filmFranceSubscribeUrls: {
    worker: 'https://salarie.app.develop.movinmotion.net/film-france-talents/signup',
    talents: 'https://talents.app.develop.movinmotion.net/film-france/signup',
  },
  odalieSubscribeUrl: 'https://odalie2.app.develop.movinmotion.net/cmbSignup',
  workerSubscribeUrl: 'https://salarie.app.develpo.movinmotion.net/inscription/autonome',
  envName: 'develop',
  sentryDsn: '',
  thirdParty: {
    mixpanel: {
      enabled: true,
    },
  },
};
